import { Avatar, Form, QRCode } from 'antd';
import { IAppointmentItemData } from 'features/booking/services/types/apt';
import styled from 'styled-components';
import { formatPhone } from 'utils/formatPhone';
import ActionsStep from './ActionsStep';
import complete_icon from './assets/complete-icon.svg';
import ic_calendar_outline from './assets/ic_calendar-outline.svg';
import ic_copy from './assets/ic_copy.svg';
import ic_request from './assets/ic_request.png';
import ic_time from './assets/ic_time.svg';
import Congratulation from './Congratulation';
import { ANY_BODY_ID_STORE_LIST } from 'features/booking/services/constants';
import anybody_icon from 'assets/Icons/icon-anybody.png';

export type IAppointmentSuccess = {
  qrCode: string;
  customerName: string;
  customerPhone: string;
  date: string;
  startTime: string;
  endTime: string;
  items: IAppointmentItemData[];
  note: string;
};
type Props = {
  value?: IAppointmentSuccess;
  deposit?: boolean;
};
const SuccessStep = ({ value, deposit }: Props) => {
  const form = Form.useFormInstance();
  if (!value) return null;
  if (deposit) {
    return (
      <>
        <Congratulation />
        <>
          <QrCodeStyled>
            <QRCode bordered={false} size={200} value={value.qrCode || ''} />
            <button type='button' className='qr-copy'>
              <span>{value.qrCode || ''}</span>
              <img src={ic_copy} alt="ic_copy" />
            </button>
          </QrCodeStyled>
          <TicketDetail>
            <CustomerStyled>
              <div className="customer-name">{value.customerName || ''}</div>
              <div className="customer-phone">{formatPhone(value.customerPhone || '')}</div>
            </CustomerStyled>
            <TimeBox>
              <div className="time-box-item">
                <img src={ic_calendar_outline} alt="ic_calendar_outline" className="icon" />
                <span>{value?.date}</span>
              </div>
              <div className="time-box-item">
                <img src={ic_time} alt="ic_time" className="icon" />
                <span>{value.startTime} - {value.endTime}</span>
              </div>
            </TimeBox>
            <StaffBox>
              {value.items.map(staff => {
                return (
                  <div key={staff.staffId} className="staff-item">
                    <div className="staff-info-row">
                      <div className="staff-name-box">
                        <Avatar src={ANY_BODY_ID_STORE_LIST.includes(staff.staffId) ? anybody_icon : staff.avatar} size={35} >{staff.staffName?.[0] || 'A'}</Avatar>
                        <span>{staff.staffName || 'A'}</span>
                      </div>
                      {staff.requestStaff && (
                        <img className='ic_request' src={ic_request} alt='ic_request' style={{ width: '41px', height: 'auto' }} />
                      )}
                    </div>

                    {staff.services.map(ser => (
                      <div key={ser.serviceId} className="service-row">
                        <span className="service-name">{ser.serviceName}</span>
                        <span>({ser.duration}m)</span>
                      </div>
                    ))}
                  </div>
                );
              })}
            </StaffBox>
            {value.note && <NoteBox>
              <span className='label'>Note:</span>
              <span>{value.note}</span>
            </NoteBox>}
          </TicketDetail>
        </>
      </>
    );
  }
  return (
    <Wrapper>
      <Congratulation />
      <Container>
        <div className="container-box">
          <Header>
            <img src={complete_icon} alt="complete_icon" />
            <p className="title">Booking Success!</p>
          </Header>
          <QrCodeStyled>
            <QRCode bordered={false} size={200} value={value.qrCode || ''} />
            <button type='button' className='qr-copy'>
              <span>{value.qrCode || ''}</span>
              <img src={ic_copy} alt="ic_copy" />
            </button>
          </QrCodeStyled>
          <TicketDetail>
            <CustomerStyled>
              <div className="customer-name">{value.customerName || ''}</div>
              <div className="customer-phone">{formatPhone(value.customerPhone || '')}</div>
            </CustomerStyled>
            <TimeBox>
              <div className="time-box-item">
                <img src={ic_calendar_outline} alt="ic_calendar_outline" className="icon" />
                <span>{value?.date}</span>
              </div>
              <div className="time-box-item">
                <img src={ic_time} alt="ic_time" className="icon" />
                <span>{value.startTime} - {value.endTime}</span>
              </div>
            </TimeBox>
            <StaffBox>
              {value.items.map(staff => {
                return (
                  <div key={staff.staffId} className="staff-item">
                    <div className="staff-info-row">
                      <div className="staff-name-box">
                        <Avatar src={ANY_BODY_ID_STORE_LIST.includes(staff.staffId) ? anybody_icon : staff.avatar} size={35} >{staff.staffName?.[0] || 'A'}</Avatar>
                        <span>{staff.staffName || 'A'}</span>
                      </div>
                      {staff.requestStaff && (
                        <img className='ic_request' src={ic_request} alt='ic_request' style={{ width: '41px', height: 'auto' }} />
                      )}
                    </div>

                    {staff.services.map(ser => (
                      <div key={ser.serviceId} className="service-row">
                        <span className="service-name">{ser.serviceName}</span>
                        <span>({ser.duration}m)</span>
                      </div>
                    ))}
                  </div>
                );
              })}
            </StaffBox>
            {value.note && <NoteBox>
              <span className='label'>Note:</span>
              <span>{value.note}</span>
            </NoteBox>}
          </TicketDetail>
        </div>
      </Container>
      <ActionsStep onBookNew={() => form.resetFields()} />
    </Wrapper>
  );
};

export default SuccessStep;

const NoteBox = styled.div`
display: flex;
padding: 4px 0;
align-items: center;
gap: 8px;
align-self: stretch;
span {
  color: #FF7D00;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.28px;
  .label {
  font-weight: 500;
  }
}
`;

const StaffBox = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  background: #F6F7FC;
  .staff-item {
    display: flex;
    padding: 0 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    background: #FFF;
    .staff-info-row {
      display: flex;
      padding-bottom: 8px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      border-bottom: 1px solid #C9CDD4;

      .staff-name-box {
        display: flex;
        align-items: center;
        gap: 4px;
        flex: 1 0 0;

        span {
          color: #1D2129;
          text-align: right;
          font-family: Poppins;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-transform: uppercase;
        }

        }
      .ic_request {
        transform: translateY(4px);
      }
    }

    .service-row {
      display: flex;
      height: 32px;
      padding-bottom: 8px;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      border-bottom: 1px solid #E5E5E5;
      span {
        color: #1D2129;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        &.service-name {
          flex: 1;  
        }
      }

      &:last-child {
        border-bottom: 1px solid transparent;
      }
    }

  }
`;

const TimeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  justify-content: space-between;
  background: #FFF;
  border-bottom: 1px dashed #C9CDD4;
  padding: 8px 0;
  .time-box-item {
    display: flex;
    align-items: center;
    gap: 4px;
    &:nth-child(0) {
      border-right: 1px solid #CCD4DC;
    }

    img {
      width: 20px;
      height: 20px;
    }

    span {
      color: #1D2129;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;

const TicketDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  padding: 0 8px;
`;

const CustomerStyled = styled.div`
display: flex;
padding-bottom: 8px;
align-items: center;
justify-content: space-between;
gap: 16px;
align-self: stretch;
border-bottom: 1px dashed #C9CDD4;
padding: 8px 0;
.customer-name {
  color: #1D2129;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.customer-phone {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
`;

const Wrapper = styled.div`
  min-height: 100vh;
  position:relative;
  background: #F5F5F5;
`;
const Container = styled.div`
  height: 100%;
  padding: 16px;
  min-height: 100vh;
  .container-box {
    display: flex;
    padding: 8px 8px 16px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    border-radius: 12px;
    background: #fff;
  }
`;

const Header = styled.div`
  display: flex;
  padding-bottom: 8px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-bottom: 1px dashed #CCD4DC;
  img {
    display: flex;
    width: 48px;
    height: 48px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
  }

  p.title {
    color: #0C865D;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const QrCodeStyled = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
align-self: stretch;
.qr-copy {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  img {
    width: 24px;
    height: 24px;
    aspect-ratio: 1/1;
  }

  span {
    color: #2463EB;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 24px */
    letter-spacing: 0.96px;
  }
}
`;